import { AxiosError } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { fetchTransferMonthlyRoyaltyExpense } from '../../services/api/Transfer';
import { ITransferMonthlyRoyaltyExpense } from '../../services/types';

enum QueryKey {
  AllRoyaltyExpense = 'AllRoyaltyExpense',
}

export const useRoyaltyExpense = (year: number): UseQueryResult<ITransferMonthlyRoyaltyExpense[], AxiosError> =>
  useQuery<ITransferMonthlyRoyaltyExpense[], AxiosError>(
    [QueryKey.AllRoyaltyExpense, { year }],
    async () => {
      const [fetchPromise] = fetchTransferMonthlyRoyaltyExpense(year);
      const result = await fetchPromise;

      if (result.status !== 200) {
        throw new Error('API Error');
      }

      return result.data;
    },
    {
      onError: e => {
        console.log(e.response ? e.response.data.message : e.message);
      },
      keepPreviousData: true,
    },
  );
